module.exports = __webpack_public_path__ + "img/nature.5d8ec47.jpg";